export interface BrowserHeaderBackAction {
  id: string;
  label: string;
  onClick: () => void;
}

type BrowserHeaderBackActionListener = (
  action: BrowserHeaderBackAction | null,
) => void;

let currentAction: BrowserHeaderBackAction | null = null;
const listeners = new Set<BrowserHeaderBackActionListener>();

export function getBrowserHeaderBackAction(): BrowserHeaderBackAction | null {
  return currentAction;
}

export function publishBrowserHeaderBackAction(
  action: BrowserHeaderBackAction | null,
): void {
  currentAction = action;
  listeners.forEach((listener) => listener(action));
}

export function clearBrowserHeaderBackAction(
  action: BrowserHeaderBackAction,
): void {
  if (currentAction?.id !== action.id || currentAction.onClick !== action.onClick) return;
  publishBrowserHeaderBackAction(null);
}

export function subscribeBrowserHeaderBackAction(
  listener: BrowserHeaderBackActionListener,
): () => void {
  listeners.add(listener);
  listener(currentAction);
  return () => listeners.delete(listener);
}
